import Axios from 'axios'

import type {
  TCreateSavedDashboardFilterRequest,
  TCreateSavedDashboardFilterResponse,
  TSavedDashboardFilterDto,
  TUpdateSavedDashboardFilterRequest,
  TUpdateSavedDashboardFilterResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/saved-dashboard-filters`

export async function getAll() {
  return getWithRedirect<TSavedDashboardFilterDto[]>(URL)
}

export async function create(body: TCreateSavedDashboardFilterRequest) {
  return Axios.post<TCreateSavedDashboardFilterResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function update(
  id: string,
  body: TUpdateSavedDashboardFilterRequest
) {
  return Axios.patch<TUpdateSavedDashboardFilterResponse>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
